require('source-map-support').install()

const yargs = require('yargs')
const shell = require('shelljs')

const {
	primary,
	accent,
	danger,
	BASE_URL,
	VERSION,
	STORAGE_DIR_PATH
} = require('./common.js')

///// INITIALIZATION

// const { isInitialized, initialize } = require('./initialize.js')
// if (!isInitialized()) initialize()

const divider = {}

// CONFIGURE COMMANDS

const commands = [
	divider,

	{
		name: "greet",
		description: "provide your name, ops will greet you"
	},
	{
		name: "ip",
		description: "get your ip address"
	},
	{
		name: "update",
		description: "update the dev cli to the latest version"
	},
	{
		name: "version",
		alias: 'v',
		description: "get the current ops version"
	},
	{
		name: "size",
		description: "get a report on the size of the client code"
	},
	divider,

	{
		name: "config",
		description: "configure the cli for your work environment and preferences"
	},
	{
		name: "purge",
		implementation: () => {
			shell.exec("rm -rf " + STORAGE_DIR_PATH)
			console.log(accent("\n\tcli storage purged.\n"))
		},
		description: "clear cli storage"
	},
	{
		name: "timecard",
		alias: "t",
		description: "generate and print your timecard"
	},
	{
		name: "icons",
		description: "open up the @leiops/icon docs"
	},
	// {
	// 	name: "bounce",
	// 	alias: "b",
	// 	description: "Bounce wildfly and notify Slack"
	// },
	// {
	// 	name: "generalconfig",
	// 	description: "Configure the cli for your work environment and preferences outside of the ops dev environment"
	// },
	// {
	// 	name: "ssh",
	// 	description: "SSH into webservices"
	// },
	divider,

	{
		name: "dev",
		description: "start the development server"
	},
	{
		name: "dist",
		description: "build ops for production"
	},
	{
		name: "docs",
		description: "generate and open the ops client documentation"
	},
	{
		name: "logs",
		description: "get the client logs as parsable json"
	},
	{
		name: "deploy",
		description: "step through pre-deploy tasks"
	},
	{
		name: "qa",
		description: "complete part or all of the ops qa script"
	},
	divider,

	{
		name: "commit",
		alias: "c",
		description: "add changes and commit"
	},
	{
		name: "sync",
		alias: "s",
		description: "sync local branch with remote"
	},
	{
		name: "build",
		description: "build the client"
	},
	divider,

	{
		name: "generate",
		alias: "g",
		description: "generate a new resource of given type"
	}

]


// SET YARGS UP

commands.forEach(({
	name,
	alias,
	description,
	implementation
}) => {
	if (!name) 
	{
		yargs.command('')
	} 
	else 
	{
		if (!implementation)
			implementation = require(`./commands/${name}`)

		if (alias) 
		{
			yargs.command(alias, false, implementation)
			description = `${description} (${alias})`
		}

		yargs.command(name, description, implementation)
	}
})

yargs
	.usage('\nops <command> [args]')
	.demand(1, "must provide a valid command\n")
	.argv


// WEBPACK FOOTER //
// ./src/index.js